module.exports = __webpack_public_path__ + "2ec2ab42d1446ba83e94332f7f70f025.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/lighthouse.png
// module id = 578
// module chunks = 0